import React from "react";
import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { _serverUrl2 } from "../../../config";

export default function TaskLog({ id, tip }) {
  const [visible, setVisible] = useState(false);
  const [log, setLog] = useState([]);

  const onClickIslemGecmisi = async () => {
    await axios
      .get(_serverUrl2 + "/main/getLog/" + tip + "/" + id)
      .then((res) => {
        if (res.data.status) {
          setLog(res.data.rows);
          setVisible(true);
        } else {
        }
      })
      .catch((err) => {});
  };

  return (
    <>
      <button
        className="orangeBtn"
        style={{ fontSize: "13px", width: "120px" }}
        onClick={() => onClickIslemGecmisi()}
      >
        İşlem Geçmişi
      </button>
      <Modal
        isOpen={visible}
        contentLabel="İşlem Geçmişi"
        closeTimeoutMS={200}
        style={customStyles}
        onRequestClose={() => setVisible(false)}
        preventScroll={true}
      >
        <div className="row">
          <div className="col-sm-12" style={{ marginBottom: "10px" }}>
            <label>İşlem Geçmişi</label>
          </div>
          <div className="col-sm-12">
            <table className="table table-sm">
              <tbody>
                {log.map((d, i) => {
                  return (
                    <tr key={i}>
                      <td>{d.date}</td>
                      <td>{d.isim_soyisim}</td>
                      <td>{d.duzenleme_icerigi}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col-sm-3">
            <button className="redBtn" onClick={() => setVisible(false)}>
              Kapat
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

const customStyles = {
  content: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "551px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    maxHeight: "80vh",
    overflow: "auto"
  },
  overlay: {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(0, 0, 0, 0.10)",
  },
};
